<template>
  <div class="of-box" style="margin-top: 0;margin-left: 0;padding-left: 0;padding-top: 0;">
    <div class="of-container is-vertical base-page-box">
      <div class="of-aside base-search-box ">
        <div class="of-filter clearfix">
          <div class="filter-left">
          </div>
          <div class="filter-right">
          </div>
        </div>
      </div>
      <div ref="vtableBox" class="of-main no-scroll">
        <div class="of-table" style="padding:0">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="boxHeight"
            :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect>

            <el-table-column prop="FixedType" label="固定费用类型" width="100">
            </el-table-column>
            <el-table-column prop="Vehicle" label="设备号" width="100">
            </el-table-column>

            <el-table-column prop="FixedCostAveDay" label="基准固定费用（元/日）" width="160">
            </el-table-column>
            <el-table-column prop="BMaintenanceDay" label="基准保养天数" width="130">
            </el-table-column>

            <el-table-column v-if="bform && bform.FixedCostType == '月'" prop="BFixedDay"
              label="基准计费天数" width="130">
            </el-table-column>

            <el-table-column prop="FixedDay" label="计费天数" width="100">
            </el-table-column>
            <el-table-column prop="TimpDay" label="出勤天数">
            </el-table-column>

            <el-table-column prop="StopDay" label="缺勤天数">
            </el-table-column>
            <el-table-column prop="MaintenanceDay" label="保养天数"
              v-if="bform && bform.FixedCostType == '日'">
            </el-table-column>
            <el-table-column prop="FixedCost" label="固定费用合计"></el-table-column>
            <el-table-column prop="TrainCount" label="月度趟次">
            </el-table-column>
            <el-table-column prop="FixedCostTrainNum" width="150"
              label="趟次固定费用平均值"></el-table-column>

          </el-table>
        </div>
      </div>
      <!-- <div class="of-aside">
        <my-pagination
          :total="total"
          :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex"
          @change="pageChange"
        ></my-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
import { getVehicleFixedList, setVehicleFixedSave } from '@/modules/contract/api/freightnew.js'
// import MyPagination from "@/components/pagination"
export default {
  name: 'Step5Page',
  components: {
    // MyPagination
  },
  props: {
    bform: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data () {
    return {
      pageQuery: {
        pageSize: 300,
        pageIndex: 1,
        sortOrder: 'desc',
        sortField: 'Vehicle',
        fastSearchFields: 'Vehicle',
        fastSearchKeyWord: '',
        MakeReportId: '',
      },
      issubmit: false,
      pageHeight: 600,
      boxHeight: 400,
      total: 0,
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
    }

  },
  computed: {},
  mounted () {
    if (this.bform) {
      this.pageQuery.MakeReportId = this.bform.Id
      this.boxHeight = 400
      this.loadPageData()
    }
  },
  methods: {
    loadPageData () {
      this.isloading = true
      getVehicleFixedList(this.pageQuery).then(res => {
        this.isloading = false
        if (res.data.Code === 0) {
          this.listData = res.data.Data.rows.map(p => {
            return {
              ...p,
              BMaintenanceDay: this.bform.MaintenanceDay,
              BFixedDay: this.bform.FixedDay,
              FixedType: this.bform.FixedCostType,
              DispatchDate: this.datetime(p.DispatchDate, 'YYYY-MM-DD')
            }
          })
          this.total = res.data.Data.total
        }
      })
    },
    reflesh () {
      this.$emit('reflesh')
    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },
  }
}
</script>

<style></style>
